(() => {
  'use strict';

  const BLOCK_SELECTOR = '.hdt-product__complementary';
  const FIELDSET_SELECTOR = '.hdt-pc--fieldset';
  const STYLE_ID = 'gw-cross-sell-arrow-styles';

  const styles = `
    /* Cross-Selling-Box als Bezugspunkt für die Pfeile */
    .hdt-product__complementary .hdt-pc--fieldset {
      position: relative;
      overflow: visible;
    }

    /* Gemeinsames Design der Navigationspfeile */
    .hdt-product__complementary .gw-cross-sell-arrow {
      position: absolute;
      top: 50%;
      z-index: 20;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      width: 34px;
      height: 34px;
      padding: 0;

      border: 2px solid #FEDD0B;
      border-radius: 50%;

      background-color: #171717;
      color: #FEDD0B;

      box-shadow:
        0 0 0 3px rgba(255, 255, 255, 0.90),
        0 0 16px rgba(254, 221, 11, 0.50),
        0 6px 16px rgba(0, 0, 0, 0.18);

      transform: translateY(-50%);
      cursor: pointer;

      transition:
        transform 0.20s ease,
        background-color 0.20s ease,
        color 0.20s ease,
        box-shadow 0.20s ease;
    }

    /* Linker Pfeil */
    .hdt-product__complementary
    .gw-cross-sell-arrow--previous {
      left: 8px;
    }

    /* Rechter Pfeil */
    .hdt-product__complementary
    .gw-cross-sell-arrow--next {
      right: 8px;
    }

    /* Pfeilsymbole */
    .hdt-product__complementary
    .gw-cross-sell-arrow svg {
      display: block;
      width: 16px;
      height: 16px;
      pointer-events: none;
    }

    /* Hover-Effekt */
    .hdt-product__complementary
    .gw-cross-sell-arrow:hover {
      background-color: #FEDD0B;
      color: #171717;

      transform: translateY(-50%) scale(1.08);

      box-shadow:
        0 0 0 3px rgba(255, 255, 255, 0.95),
        0 0 22px rgba(254, 221, 11, 0.75),
        0 8px 20px rgba(0, 0, 0, 0.20);
    }

    /* Tastaturfokus */
    .hdt-product__complementary
    .gw-cross-sell-arrow:focus-visible {
      outline: 3px solid #171717;
      outline-offset: 3px;
    }

    /* Mobile Darstellung */
    @media screen and (max-width: 767px) {
      .hdt-product__complementary .gw-cross-sell-arrow {
        top: 50%;
        width: 30px;
        height: 30px;
      }

      .hdt-product__complementary
      .gw-cross-sell-arrow--previous {
        left: 4px;
      }

      .hdt-product__complementary
      .gw-cross-sell-arrow--next {
        right: 4px;
      }

      .hdt-product__complementary
      .gw-cross-sell-arrow svg {
        width: 14px;
        height: 14px;
      }
    }

    /* Animationen für Nutzer mit reduzierter Bewegung deaktivieren */
    @media (prefers-reduced-motion: reduce) {
      .hdt-product__complementary .gw-cross-sell-arrow {
        transition: none;
      }
    }
  `;

  function addStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const styleElement = document.createElement('style');
    styleElement.id = STYLE_ID;
    styleElement.textContent = styles;

    document.head.appendChild(styleElement);
  }

  function getSliderDots(block) {
    return Array.from(
      block.querySelectorAll(
        '.hdt-slider-dots button, ' +
        '.hdt-slider__dot, ' +
        '[data-slider-dot]'
      )
    );
  }

  function getActiveDotIndex(dots) {
    const activeIndex = dots.findIndex((dot) => {
      return (
        dot.getAttribute('aria-current') === 'true' ||
        dot.classList.contains('is-active') ||
        dot.classList.contains('active')
      );
    });

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function moveSlider(block, direction) {
    const nativeButtonSelector =
      direction > 0
        ? '.hdt-slider-nav button[name="next"], [data-next]'
        : '.hdt-slider-nav button[name="previous"], [data-prev]';

    const nativeButton = block.querySelector(
      nativeButtonSelector
    );

    /*
     * Wenn das Theme eine eigene Slider-Navigation besitzt,
     * wird diese bevorzugt verwendet.
     */
    if (nativeButton && !nativeButton.disabled) {
      nativeButton.click();
      return;
    }

    /*
     * Ersatzsteuerung über die vorhandenen Slider-Punkte.
     */
    const dots = getSliderDots(block);

    if (dots.length < 2) {
      return;
    }

    const currentIndex = getActiveDotIndex(dots);

    const targetIndex =
      (currentIndex + direction + dots.length) %
      dots.length;

    const targetDot = dots[targetIndex];

    if (targetDot) {
      targetDot.click();
    }
  }

  function createArrowButton(direction) {
    const isNextButton = direction === 'next';

    const button = document.createElement('button');

    button.type = 'button';

    button.className =
      `gw-cross-sell-arrow ` +
      `gw-cross-sell-arrow--${direction}`;

    button.setAttribute(
      'aria-label',
      isNextButton
        ? 'Nächste passende Ergänzung'
        : 'Vorherige passende Ergänzung'
    );

    button.innerHTML = isNextButton
      ? `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M9 5l7 7-7 7"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      `
      : `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15 5l-7 7 7 7"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      `;

    return button;
  }

  function initializeCrossSellBlock(block) {
    const fieldset = block.querySelector(
      FIELDSET_SELECTOR
    );

    const dots = getSliderDots(block);

    /*
     * Keine Pfeile anzeigen, wenn kein Slider
     * oder nur ein einziges Produkt vorhanden ist.
     */
    if (!fieldset || dots.length < 2) {
      return;
    }

    /*
     * Doppelte Pfeile verhindern.
     */
    if (
      fieldset.querySelector(
        '.gw-cross-sell-arrow'
      )
    ) {
      return;
    }

    const previousButton =
      createArrowButton('previous');

    const nextButton =
      createArrowButton('next');

    previousButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        moveSlider(block, -1);
      }
    );

    nextButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        moveSlider(block, 1);
      }
    );

    fieldset.appendChild(previousButton);
    fieldset.appendChild(nextButton);
  }

  function initializeAllCrossSellBlocks() {
    addStyles();

    document
      .querySelectorAll(BLOCK_SELECTOR)
      .forEach(initializeCrossSellBlock);
  }

  function scheduleInitialization() {
    window.requestAnimationFrame(
      initializeAllCrossSellBlocks
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleInitialization,
      { once: true }
    );
  } else {
    scheduleInitialization();
  }

  /*
   * Erneute Initialisierung bei dynamisch
   * nachgeladenen Shopify- oder Theme-Inhalten.
   */
  const observer = new MutationObserver(
    scheduleInitialization
  );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  /*
   * Unterstützung für den Shopify-Theme-Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    scheduleInitialization
  );

  document.addEventListener(
    'shopify:block:select',
    scheduleInitialization
  );
})();